import React, { useEffect, useState } from "react";
import Card from "components/card";
import { getNotificationLogs, sendNotification } from "services/notifications";
import { useToast } from "components/Toast";

const AdminNotifications: React.FC = () => {
  const [list, setList] = useState<any[]>([]);
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  const load = async () => {
    try {
      const data = await getNotificationLogs();
      const items = Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data)
        ? data
        : [];
      setList(items);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const toast = useToast();

  const handleSend = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await sendNotification({ title, body });
      setTitle("");
      setBody("");
      load();
      toast.showSuccess("Notification queued/sent");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to send notification");
    }
  };

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Notifications</h2>
      <form onSubmit={handleSend} className="mb-6 space-y-3">
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Title"
          className="input w-full"
        />
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Message"
          className="input w-full"
        />
        <div>
          <button className="rounded bg-indigo-600 px-4 py-2 text-white">
            Send
          </button>
        </div>
      </form>

      <div>
        <h3 className="mb-2 text-lg font-semibold">Recent Notifications</h3>
        <div className="space-y-2">
          {list.length === 0 ? (
            <div className="text-gray-500">No notifications</div>
          ) : (
            list.map((n) => (
              <div key={n.id} className="rounded border p-3">
                <div className="font-semibold">{n.title}</div>
                <div className="text-sm text-gray-600">{n.body}</div>
              </div>
            ))
          )}
        </div>
      </div>
    </Card>
  );
};

export default AdminNotifications;
